import React from 'react';
import axios from 'axios';
import apiUrl from './base_url';
import './solution/solution-refactored.css';
import ReactHtmlParser from 'react-html-parser';
import {
  FaBars,
  FaCheckCircle,
  FaCircle,
  FaClock,
  FaExpand,
  FaQuestionCircle,
  FaTimes,
  FaUserCircle,
} from 'react-icons/fa';
import { Container, Modal } from 'react-bootstrap';

import SectionTabs from './solution/SectionTabs';
import QuestionCard from './solution/QuestionCard';
import AnalysisSummary from './solution/AnalysisSummary';
import QuestionPalette from './solution/QuestionPalette';
import MobileQuestionModal from './solution/MobileQuestionModal';

class Solution extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fullscreen: true,
      show: false,
      isFullScreen: false,
      showSidebar: false,

      exam_id: '',
      dcategory: [],
      section: [],
      question: [],

      markedbackup: [],
      savedbackup: [],
      visitedbackup: [],

      currentQuestionIndex: null,
      currentSection: null,
      showAnswer: false,
    };
  }

  componentDidMount() {
    const exam_id =
      this.props.location.state?.exam_id ||
      localStorage.getItem('exam_id1');

    if (!exam_id) {
      console.error('exam_id is not defined');
      return;
    }

    localStorage.setItem('exam_id1', exam_id);
    this.setState({ exam_id });

    axios
      .get(`${apiUrl}serverside/getsection.php?exam_id=${exam_id}`)
      .then(({ data }) => {
        this.setState({ section: Array.isArray(data) ? data : [] });
      })
      .catch(error => console.error(error));

    axios
      .get(`${apiUrl}serverside/dashboard_category.php?exam_id=${exam_id}`)
      .then(({ data }) => {
        this.setState({ dcategory: Array.isArray(data) ? data : [] });
      })
      .catch(error => console.error(error));

    // Load first available section.
    axios
      .get(`${apiUrl}serverside/getsection.php?exam_id=${exam_id}`)
      .then(({ data }) => {
        if (Array.isArray(data) && data.length > 0) {
          this.loadAllQuestions(
            data[0].sec_id,
            data[0].section_name
          );
        }
      })
      .catch(error => console.error(error));
  }

  handleFullScreenToggle = async () => {
    try {
      if (document.fullscreenElement) {
        await document.exitFullscreen();
        this.setState({ isFullScreen: false });
      } else {
        await document.documentElement.requestFullscreen();
        this.setState({ isFullScreen: true });
      }
    } catch (error) {
      console.error('Fullscreen error:', error);
    }
  };

  handleShow = breakpoint => {
    this.setState({
      fullscreen: breakpoint,
      show: true,
    });
  };

  handleCopy = event => {
    event.preventDefault();
    alert('Copying text is not allowed on this page.');
  };

  refreshBackupData = examId => {
    const regid = localStorage.getItem('regid');

    if (!regid || !examId) return;

    const requests = [
      axios.get(
        `${apiUrl}serverside/marked_backup.php?exam_id=${examId}&regid=${regid}`
      ),
      axios.get(
        `${apiUrl}serverside/save_backup.php?exam_id=${examId}&regid=${regid}`
      ),
      axios.get(
        `${apiUrl}serverside/visited_backup.php?exam_id=${examId}&regid=${regid}`
      ),
    ];

    Promise.all(requests)
      .then(([marked, saved, visited]) => {
        this.setState({
          markedbackup: Array.isArray(marked.data) ? marked.data : [],
          savedbackup: Array.isArray(saved.data) ? saved.data : [],
          visitedbackup: Array.isArray(visited.data) ? visited.data : [],
        });
      })
      .catch(error => console.error(error));
  };

  loadQuestion = index => {
    const examId = this.state.exam_id || localStorage.getItem('exam_id1');
    const secId = localStorage.getItem('secl_id');

    if (!secId || index === null || index === undefined) return;

    this.refreshBackupData(examId);

    axios
      .get(`${apiUrl}serverside/getquestion.php?sec_id=${secId}&index=${index}`)
      .then(({ data }) => {
        const questions = Array.isArray(data) ? data : [];

        this.setState({
          question: questions,
          currentQuestionIndex: index,
          showAnswer: false,
        });
      })
      .catch(error => console.error(error));
  };

  loadAllQuestions = (secId, sectionName) => {
    if (!secId) return;

    localStorage.setItem('secl_id', secId);

    axios
      .get(`${apiUrl}serverside/getquestion.php?sec_id=${secId}`)
      .then(({ data }) => {
        const questions = Array.isArray(data) ? data : [];

        this.setState(
          {
            question: questions,
            currentSection: sectionName || '',
            currentQuestionIndex: questions.length ? 0 : null,
            showAnswer: false,
          },
          () => {
            this.refreshBackupData(
              this.state.exam_id || localStorage.getItem('exam_id1')
            );
          }
        );
      })
      .catch(error => console.error(error));
  };

  saveCurrentAnswer = () => {
    const { question, currentQuestionIndex, dcategory, exam_id } =
      this.state;

    const currentQuestion =
      question && question[currentQuestionIndex];

    if (!currentQuestion) return Promise.resolve();

    const regid = localStorage.getItem('regid');
    const email = localStorage.getItem('email');
    const answerElement = document.querySelector(
      'input[name="solution-answer"]:checked'
    );

    const answer = answerElement ? answerElement.value : 0;
    const a_id = dcategory?.[0]?.a_id || '';

    const payload = {
      email,
      regid,
      exam_id: exam_id || localStorage.getItem('exam_id'),
      a_id,
      q_id: currentQuestion.q_id,
      answer,
    };

    return Promise.all([
      axios.post(`${apiUrl}serverside/savequestion.php`, payload),
      axios.post(`${apiUrl}serverside/visitedquestion.php`, payload),
    ]).then(() => {
      this.refreshBackupData(
        exam_id || localStorage.getItem('exam_id1')
      );
    });
  };

  handleNextClick = async () => {
    const { question, currentQuestionIndex } = this.state;

    if (!Array.isArray(question) || currentQuestionIndex === null) {
      return;
    }

    try {
      await this.saveCurrentAnswer();
    } catch (error) {
      console.error(error);
    }

    const nextIndex = currentQuestionIndex + 1;

    if (nextIndex < question.length) {
      this.loadQuestion(nextIndex);
      return;
    }

    const { section } = this.state;
    const currentSectionIndex = section.findIndex(
      item => item.sec_id.toString() ===
        localStorage.getItem('secl_id')?.toString()
    );

    const nextSection = section[currentSectionIndex + 1];

    if (nextSection) {
      this.loadAllQuestions(
        nextSection.sec_id,
        nextSection.section_name
      );
      return;
    }

    // Preserve the original wrap-around behavior.
    if (section[0]) {
      this.loadAllQuestions(
        section[0].sec_id,
        section[0].section_name
      );
    }
  };

  getQuestionStatus = questionId => {
    const id = String(questionId);

    const saved = this.state.savedbackup.some(
      item => String(item.q_id) === id
    );
    const marked = this.state.markedbackup.some(
      item => String(item.q_id) === id
    );
    const visited = this.state.visitedbackup.some(
      item => String(item.q_id) === id
    );

    // Review takes visual priority only when the question has not been answered.
    if (saved && marked) return 'answeredReview';
    if (saved) return 'answered';
    if (marked) return 'marked';
    if (visited) return 'visited';
    return 'notVisited';
  };

  handleQuestionSelect = index => {
    this.loadQuestion(index);
    this.setState({ show: false });
  };

  render() {
    const {
      dcategory,
      section,
      question,
      currentQuestionIndex,
      currentSection,
      showAnswer,
      show,
      fullscreen,
      isFullScreen,
      showSidebar,
    } = this.state;

    const email = localStorage.getItem('email');
    const regid = localStorage.getItem('regid');

    if (!email || !regid) {
      this.props.history.push('/login');
      return null;
    }

    const currentQuestion =
      question?.[currentQuestionIndex];

    const answered = this.state.savedbackup.length;
    const marked = this.state.markedbackup.length;
    const visited = this.state.visitedbackup.length;
    const notAnswered = Math.max(visited - answered, 0);
    const notVisited = Math.max(
      question.length - visited,
      0
    );

    const examTitle =
      dcategory?.[0]?.topic_name || 'Test Series Analysis';

    return (
      <Container
        fluid
        className="solution-page"
        onCopy={this.handleCopy}
      >
        <div className="solution-layout">
          <main className="solution-main">
            <SectionTabs
              sections={section}
              activeSection={currentSection}
              onSelect={this.loadAllQuestions}
            />

            <QuestionCard
              question={currentQuestion}
              questionIndex={currentQuestionIndex}
              savedbackup={this.state.savedbackup}
              markedbackup={this.state.markedbackup}
              showAnswer={showAnswer}
            />

            {currentQuestion && (
              <div className="solution-actions">
                <button
                  type="button"
                  className="solution-secondary-btn"
                  onClick={() =>
                    this.setState({
                      showAnswer: !showAnswer,
                    })
                  }
                >
                  {showAnswer ? 'Hide Answer' : 'View Answer'}
                </button>

                <button
                  type="button"
                  className="solution-primary-btn"
                  onClick={this.handleNextClick}
                >
                  Next Question
                  <span aria-hidden="true">→</span>
                </button>
              </div>
            )}
          </main>

          <aside
            className={`solution-sidebar ${
              showSidebar ? 'is-open' : ''
            }`}
          >
            <div className="sidebar-mobile-close">
              <button
                type="button"
                onClick={() =>
                  this.setState({ showSidebar: false })
                }
              >
                <FaTimes />
              </button>
            </div>

            <AnalysisSummary
              email={email}
              answered={answered}
              marked={marked}
              visited={visited}
              notAnswered={notAnswered}
              notVisited={notVisited}
            />

            <QuestionPalette
              questions={question}
              currentQuestionIndex={currentQuestionIndex}
              getQuestionStatus={this.getQuestionStatus}
              onSelect={this.handleQuestionSelect}
            />
          </aside>
        </div>

        <button
          type="button"
          className="mobile-palette-trigger"
          onClick={() => this.handleShow('sm')}
          aria-label="Open question palette"
        >
          <FaBars />
          <span>Questions</span>
        </button>

        <MobileQuestionModal
          show={show}
          fullscreen={fullscreen}
          email={email}
          questions={question}
          currentQuestionIndex={currentQuestionIndex}
          getQuestionStatus={this.getQuestionStatus}
          onSelect={this.handleQuestionSelect}
          onClose={() => this.setState({ show: false })}
        />
      </Container>
    );
  }
}

export default Solution;
